import { render, staticRenderFns } from "./suggest.vue?vue&type=template&id=1ef4d591&scoped=true"
import script from "./suggest.vue?vue&type=script&lang=js"
export * from "./suggest.vue?vue&type=script&lang=js"
import style0 from "./suggest.vue?vue&type=style&index=0&id=1ef4d591&prod&scoped=true&lang=scss"
import style1 from "./suggest.vue?vue&type=style&index=1&id=1ef4d591&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4d591",
  null
  
)

export default component.exports